import React from 'react';
import { Box, Grid, IconButton, Typography, useMediaQuery } from '@material-ui/core';
import { makeStyles, useTheme } from '@material-ui/styles';
import { Link } from 'react-scroll';
import { motion } from "framer-motion";


const useStyles = makeStyles((theme) => ({
    section: {
        height: '100vh',
        padding: '4em',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat'
    },
    logos: {
        height: '4em',
    },
    dummys: {
        height: '100vh'
    }
}));

const bounceTransition = {
    y: {
        duration: 1,
        yoyo: 3,
        ease: "easeIn",
    },
    backgroundColor: {
        duration: 0,
        yoyo: 3,
        ease: "easeOut",
        repeatDelay: 1,
    },
};

const Down = (props) => <motion.div {...props}></motion.div>;

const ProductHeaderView = ({ title, description, image }) => {

    const classes = useStyles();
    const theme = useTheme();

    const matchesXS = useMediaQuery(theme.breakpoints.up('xs'));
    const matchesSM = useMediaQuery(theme.breakpoints.up('sm'));
    const matchesMD = useMediaQuery(theme.breakpoints.up('md'));
    const matchesLG = useMediaQuery(theme.breakpoints.up('lg'));
    const matchesXL = useMediaQuery(theme.breakpoints.up('xl'));

    const titleVariant = matchesXL ? 'h1' : matchesLG ? 'h2' : matchesMD ? 'h3' : matchesSM ? 'h4' : matchesXS ? 'h5' : 'h6';
    const textVariant = matchesXL ? 'h3' : matchesLG ? 'h4' : matchesMD ? 'h5' : matchesSM ? 'h6' : matchesXS ? 'body1' : 'body1';


    return (
        <Grid container direction="column" className={classes.section} style={{ backgroundImage: `url(${image})` }}>
            <Grid item >
                <Typography variant={titleVariant} align="center">
                    <Box fontWeight={900} lineHeight={2} letterSpacing={2} color={theme.palette.arenco.darkBlue} align="left">
                        {title}
                    </Box>
                </Typography>
            </Grid>
            <Grid item >
                <Typography variant={textVariant} >
                    <Box fontWeight={500} lineHeight={1.5} color={theme.palette.arenco.darkBlue} align="left">
                        {description}
                    </Box>
                </Typography>
            </Grid>
        </Grid >
    );
};

export default ProductHeaderView;